//$Id$
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '../app/home/main.component';
import { AdministrationComponent } from '../app/home/paraEmpresas/administration/content.component';
import { ConsumeComponent } from '../app/home/paraEmpresas/consume/content.component';
import { BlockComponent } from 'app/home/paraEmpresas/block/content.component';
import { VivoSyncComponent } from 'app/home/paraEmpresas/vivosync/content.component';
import { PackagesComponent } from 'app/home/paraEmpresas/packages/content.component';
import { CalendarComponent } from 'app/home/paraEmpresas/calendar/content.component';
import { ReportsComponent } from 'app/home/paraEmpresas/reports/content.component';
import { StepsComponent } from 'app/home/paraEmpresas/steps/content.component';
import { LoginComponent } from 'app/home/paraEmpresas/login/content.component';
import { CanLeaveSyncGuard } from './home/paraEmpresas/vivosync/canleavesyncguard/content.component';
import { CanEnterSyncGuard } from 'app/home/paraEmpresas/header/canentersyncguard/content.component';

/**
 * @author Wesley Mascarenhas
 * @version $Id$
 */
export const routes: Routes = [
  { path: 'Portal', redirectTo: '/Portal/data/login', pathMatch: 'full' },
  { path: 'Portal/data', redirectTo: '/Portal/data/login', pathMatch: 'full' },
  { path: 'Portal/pages/authenticate', redirectTo: '/Portal/data/login', pathMatch: 'full' },
  {
    path: 'Portal/data',
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'consumption',
        component: ConsumeComponent,
        data: {
          breadcrumb: 'Consumo'
        }
      },
      {
        path: 'administration',
        component: AdministrationComponent,
        data: {
          breadcrumb: 'Administração da Conta'
        }
      },
      {
        path: 'block',
        component: BlockComponent,
        data: {
          breadcrumb: 'Bloqueios'
        }
      },
      //{
      //path: 'packages',
      //component: PackagesComponent,
      //  data: {
      //    breadcrumb: 'Pacote Adicional'
      //  }
      //},
      {
        path: 'calendar',
        component: CalendarComponent,
        data: {
          breadcrumb: 'Calendário'
        }
      },
      {
        path: 'reports',
        component: ReportsComponent,
        data: {
          breadcrumb: 'Relatórios'
        }
      },
      {
        path: 'vivosync',
        component: VivoSyncComponent,
        canDeactivate: [CanLeaveSyncGuard],
        canActivate: [CanEnterSyncGuard],
        data: {
          breadcrumb: 'Vivo Sync Empresas'
        }
      },
      {
        path: 'steps',
        component: StepsComponent,
        data: {
          breadcrumb: 'Primeiros Passos'
        }
      }
    ]
  }
];
export const ALL_ROUTES: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts